"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _buildUrl = _interopRequireDefault(require("../utils/buildUrl"));
var _useQIndex = _interopRequireDefault(require("./useQIndex"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const locationQuerySetter = _ref => {
  let {
    location,
    history,
    nsValues
  } = _ref;
  const {
    pathname,
    search
  } = location;
  const url = (0, _buildUrl.default)(location, nsValues);

  // Do not push to history if the url didn't change
  // https://issues.folio.org/browse/STSMACOM-637
  if (`${pathname}${search}` !== url) {
    history.push(url);
  }
};
const useKiwtSASQuery = () => {
  const history = (0, _reactRouterDom.useHistory)();
  const location = (0, _reactRouterDom.useLocation)();
  const [query, setQuery] = (0, _react.useState)({});
  const queryGetter = () => query;
  const [qindex] = (0, _useQIndex.default)();
  // Ensure we update the query along with the querySetter
  if (query.qindex !== qindex) {
    setQuery({
      ...query,
      qindex
    });
  }
  const querySetter = _ref2 => {
    let {
      nsValues
    } = _ref2;
    setQuery({
      ...query,
      ...nsValues,
      qindex
    });
    locationQuerySetter({
      location,
      history,
      nsValues
    });
  };
  return {
    query,
    queryGetter,
    querySetter
  };
};
var _default = exports.default = useKiwtSASQuery;